import Icon from 'antd/lib/icon'
import styled from 'styled-components'
import { WHITE, GRAY_DARK, BLUE, WHITE_TRANSPARENT, GRAY_LIGHT, GRAY_STRONG } from '../../theme/colors'
import { AVENIR_NEXT } from '../../theme/fonts'

interface StyleProps {
  action?: boolean
  small?: boolean
  secondary?: boolean
  tone?: 'warning' | 'error' | 'neutral'
}

export const IntakeContainer = styled.div`
  background-color: ${WHITE};
  width: 100%;
  .thumbnail-container {
    /* margin-top: 16px; */
  }
  .thumbnail-container-search-input {
    flex-direction: column;
    justify-content: center;
    margin-top: 16px;
  }
  @media (max-width: 768px) {
    overflow-y: scroll;
    height: ${({ secondary }: StyleProps) => secondary ? 'auto' : 'calc(100vh - 120px)'};
  }
`

export const SavingDiv = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  background: ${({ small }: StyleProps) => small ? 'none' : WHITE_TRANSPARENT};
  z-index: 777;
  top: 0;
  left: 0;
`

export const LoaderImg = styled.img`
  max-width: 128px;
`

export const Title = styled.div`
  font-weight: 600;
  font-size: 19px;
  margin-top: 20px;
  font-family: "Avenir Next";
  @media (max-width: 768px) {
    margin: 0;
  }
  span {
    font-weight: normal;
  }
  &[data-section="3"] {
    @media (max-width: 320px) {
      color: #302628;
      padding-inline: 32px;
      padding-bottom: 12px;
    }
  }
`

export const Subtitle = styled.div`
  margin-top: 14px;
  max-width: 924px;
  font-family: "Avenir Next";
  font-size: ${({ small }: StyleProps) => (small ? '14px' : '16px')};
  text-align: start;
  ${({ secondary }: StyleProps) => secondary ? `
    display: flex;
    max-width: 848px;
    background: rgba(33, 150, 243, 0.10);
    border: 1px solid #2196F3;
    border-radius: 8px;
    padding: 10px 10px 0px 10px;
    p {
      @media (max-width: 320px) {
        font-size: 13px !important;
      }
      margin-left: 10px;
      :first-child {
        font-weight: 700;
      }
      :last-child {
        font-weight: 500;
        margin-top: -10px;
        @media (max-width: 320px) {
          margin-top: -4px;
        }
      }
      span.bold { 
        color: #625F5F;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
      }
      &.light {
        font-weight: 400;
        margin-top: 24px;
      }
    }
  ` : `
    color: ${({ action }: StyleProps) => (action ? BLUE : GRAY_DARK)};
    cursor: ${({ action }: StyleProps) => (action ? 'pointer' : 'normal')};
    p {
      @media (max-width: 320px) {
        font-size: 13px !important;
      }
      :first-child {
        font-weight: 400;
      }
      :last-child {
        font-weight: 500;
        margin-top: -10px;
        @media (max-width: 320px) {
          margin-top: -4px;
        }
      }
      &.light {
        font-weight: 400;
        margin-top: 24px;
      }
      span.bold { 
        color: #625F5F;
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
      }
    }
  `}
  ${({ small }: StyleProps) => small && `
    color: #2196F3;
    text-align: center;
    font-family: "Avenir Next";
    font-size: 13px;
    font-weight: 500;
  `}
`

export const SubTopDiv = styled.div`
  margin-bottom: 10px;
  @media (max-width: 748px) {
    margin-bottom: 20px;
    max-width: 250px;
  }
`

export const TopNavHeader = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  align-items: center;
  @media (max-width: 320px) {
    padding-bottom: 0px;
  }
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
  margin-bottom: 5px;
`

export const FileTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 18px;
  margin-bottom: 15px;
  @media (max-width: 767px) {
    font-size: 16px;
  }
`

export const ComparisonDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-flow: row;
  @media (max-width: 767px) {
    flex-flow: column;
  }
`

export const RasterContent = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: column;
  margin-left: -22px;
`

export const BottomText = styled.div`
  text-align: center;
  margin-top: 20px;
`

export const RasterDiv = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  flex: 1;
  margin-right: 32px;
  &:last-child {
    margin-right: 0px;
  }
  @media (max-width: 767px) {
    margin-right: 0px;
  }
`

export const RasterImage = styled.img`
  max-width: 228px;
  width: 100%;
`

export const ModalIcon = styled(Icon)`
  right: 26px;
  position: absolute;
  font-size: 18px;
`

export const RasterText = styled.div``

export const InfoText = styled.div`
  text-align: center;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const buttonStyle = {
  background: BLUE,
  border: 'none'
}

export const buttonStyleModern = {
  background: WHITE,
  color: GRAY_STRONG,
  borderColor: GRAY_LIGHT,
  textShadow: 'none'
}

export const EditContent = styled.div`
  margin: 22px 0 28px -38px;
  text-align: center;
  line-height: 1;
  font-size: 15px;
`

export const TitleEdit = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
`

export const ProjectsIcon = styled(Icon)`
  margin-right: 12px;
  &#close {
    right: 6px;
    position: absolute;
    font-size: 14px;
    border: 1px solid #b3b3b3;
    border-radius: 25px;
    padding: 3px;
    top: 14px;
    color: #616161;
    :hover {
      cursor: pointer;
    }
  }
`

export const ProjectList = styled.div`
  margin: 22px 0 22px -38px;
`

export const ProjectRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  margin: 4px 0;
  border-top: 1px solid #e8e8e8;
  align-items: center;
`

export const ProjectName = styled.div`
  font-weight: 500;
  font-family: Avenir;
`

export const AddProduct = styled.div`
  background: ${WHITE};
  padding: 4px 11px;
  font-size: 12px;
  border: 1px solid ${BLUE};
  color: ${BLUE};
  border-radius: 3px;
  box-shadow: 1px 1px 3px -1px #c9c9c9;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const BaseCard = styled.div`
  max-width: 128px;
  width: 100%;
  box-shadow: 0px 1px 3px 1px #d3d3d3;
  border-radius: 3px;
  margin-bottom: 18px;
  border: ${({ secondary }: StyleProps) => secondary ? '2px solid cornflowerblue' : 'unset'};
  transition: all .25s;
  &:hover {
    transform: scale(1.04);
    cursor: pointer;
    box-shadow: 0px 1px 3px 1px #b4b4b4;
  }
`

export const VinylCard = styled.div`
  max-width: 184px;
  width: 100%;
  box-shadow: 0px 1px 3px 1px #d3d3d3;
  border-radius: 3px;
  margin-bottom: 18px;
  border: ${({ secondary }: StyleProps) => secondary ? '2px solid cornflowerblue' : 'unset'};
  transition: all .25s;
  &:hover {
    transform: scale(1.04);
    cursor: pointer;
    box-shadow: 0px 1px 3px 1px #b4b4b4;
  }
  @media (max-width: 698px) {
    max-width: 130px;
  }
`

export const BaseImg = styled.img`
  max-width: 100%;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`

export const MatImg = styled.img`
  max-width: 100%;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`

export const ContinueBtn = styled.div`
  background: cornflowerblue;
  width: fit-content;
  margin-top: 12px;
  padding: 8px 22px;
  border-radius: 5px;
  color: white;
  box-shadow: 0px 1px 3px 0px #919191;
  margin-bottom: -4px;
  &:hover {
    cursor: pointer;
    opacity: 0.7
  }
`

export const BackBtn = styled.div`
  background: white;
  width: fit-content;
  margin-top: 12px;
  padding: 8px 22px;
  border-radius: 5px;
  box-shadow: 0px 1px 3px 0px #919191;
  margin-bottom: -4px;
  &:hover {
    cursor: pointer;
    opacity: 0.7
  }
`

export const MaterialsDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  column-gap: 48px;
  @media (max-width: 698px) {
    column-gap: 16px;
  }
`

export const GoBackBtn = styled.div`
  border: 1px solid #e6e6e6;
  color: #8e8e8e;
  width: fit-content;
  padding: 5px 6px;
  border-radius: 4px;
  position: absolute;
  left: 32px;
  top: 30px;
  font-size: 12px;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 698px) {
    left: 14px;
  }
`

export const WarningIcon = styled(Icon)``

export const intakeBackButtonStyle = {
  background: '#FFFFFF',
  color: '#3f3f3f',
  border: '1.5px solid #3f3f3f',
  borderRadius: '18px',
  width: '90%',
  margin: '0px 26px 14px',
  fontFamily: 'Avenir',
  fontWeight: 500
}

export const intakePrimaryButtonStyle = {
  background: '#2b2126',
  color: '#FFFFFF',
  border: '1.5px solid #2b2126',
  borderRadius: '18px',
  width: '90%',
  margin: '0px 20px 8px 8px',
  fontFamily: 'Avenir',
  fontWeight: 500
}

export const IntakeConfirmContent = styled.div`
  margin-left: -32px;
  margin-right: 6px;
  padding: 22px 16px 8px;
  #closeModal {
    float: right;
    font-size: 20px;
    margin-top: -2px;
    cursor: pointer;
  }
  &[data-modal-content="intake-confirm"] {
    font-family: ${AVENIR_NEXT};
    text-align: left;
  }

  .intake-confirm-header {
    display: flex;
    align-items: start;
    gap: 8px;
    margin-bottom: 10px;
  }

  &[data-modal-variant="none"] .intake-confirm-icon {
    display: block;
    font-size: 24px;
    color: #C91731;
    margin-right: 12px;
  }

  .intake-confirm-title {
    color: ${GRAY_DARK};
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
  }

  .intake-confirm-body {
    color: #8c8c8c;
    font-size: 14px;
    line-height: 22px;
    font-style: normal;
    font-weight: 400;
    margin-bottom: 10px;
    padding-left: 24px;
  }

  &[data-modal-variant="partial"] .intake-confirm-title {
    font-size: 16px;
  }

  &[data-modal-variant="none"] .intake-confirm-body {
    display: flex;
    align-items: center;
    color: #302628;
    line-height: 20px;
    margin-bottom: 18px;
    padding: 12px 24px;
    border-radius: 8px;
    border: 1px solid #C91731;
    background: rgba(201, 23, 49, 0.12);
  }

  &[data-modal-variant="unsaved"],
  &[data-modal-variant="files"] {
    .intake-confirm-title {
      font-size: 22px;
      font-weight: 500;
      letter-spacing: 0.4px;
    }
    .intake-confirm-body {
      padding-block: 12px 4px;
      text-align: center;
      padding-inline: 14px;
      border-top: 1px solid lightgray;
      margin-top: 16px;
    }
  }

  &[data-modal-tone="warning"] .intake-confirm-icon {
    color: #b7b7b7;
    font-size: 18px;
  }

  &[data-modal-tone="error"] .intake-confirm-icon {
    color: #f5222d;
  }

  &[data-modal-tone="neutral"] .intake-confirm-icon {
    color: #8c8c8c;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/styledComponents.tsx